export default "__VITE_ASSET__PiqWjJ_6__"